'use client';

import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { Button, ListPageHeader } from '@terra/ui-design-system';
import { useTargetId } from '../../../store/projectStore';
import { CrawlerHistoryDrawer } from '../../crawler';
import { ErrorBoundary } from '../../ErrorBoundary';

export function AssetsPageHeader() {
  const t = useTranslations('proxy.assets.page');
  const tAssets = useTranslations('aiApplications.assets');
  const applicationId = useTargetId();
  const [isMappingHistoryOpen, setIsMappingHistoryOpen] = useState(false);
  const closeMappingHistory = () => setIsMappingHistoryOpen(false);

  return (
    <>
      <ListPageHeader
        title={t('title')}
        subtitle={t('subtitle')}
        actions={
          applicationId
            ? [
                <Button
                  key="mapping-history"
                  size="xs"
                  variant="outline"
                  onClick={() => setIsMappingHistoryOpen(true)}
                >
                  {tAssets('openScans')}
                </Button>,
              ]
            : undefined
        }
      />
      {applicationId ? (
        <ErrorBoundary
          scopeId={`assets-mapping-history-${applicationId}`}
          onClose={closeMappingHistory}
        >
          <CrawlerHistoryDrawer
            applicationId={applicationId}
            isOpen={isMappingHistoryOpen}
            onClose={closeMappingHistory}
          />
        </ErrorBoundary>
      ) : null}
    </>
  );
}
